/**
 * localStorage の安全な JSON 読み書きヘルパー（自前・GPL非依存・依存ゼロ）。
 *
 * - すべて try/catch でラップし、保存域不足（QuotaExceeded）・プライベートモード・
 *   破損 JSON などの例外でアプリが落ちないようにする（失敗時は read=null / write=無視）。
 * - 値の妥当性検証は呼び出し側（session.ts 等）の責務。本モジュールは I/O のみ担う。
 */

/** key の JSON を読み、T として返す。未設定・破損・例外時は null。 */
export const readJson = <T>(key: string): T | null => {
  try {
    const raw = localStorage.getItem(key);
    if (raw === null) return null;
    return JSON.parse(raw) as T;
  } catch (err) {
    console.error(`${key}: localStorage 読み込み失敗:`, err);
    return null;
  }
};

/** value を JSON 化して key に保存する。例外時はログのみ（保存は諦める）。 */
export const writeJson = <T>(key: string, value: T): void => {
  try {
    localStorage.setItem(key, JSON.stringify(value));
  } catch (err) {
    console.error(`${key}: localStorage 保存失敗:`, err);
  }
};

/** key を削除する。例外時はログのみ。 */
export const removeKey = (key: string): void => {
  try {
    localStorage.removeItem(key);
  } catch (err) {
    console.error(`${key}: localStorage 削除失敗:`, err);
  }
};
